<template>
    <div>

        <vue-headful title="Training Course Email Alert :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses`">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses/alerts`">
                        Expiring Course Alerts
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses/alerts/view/${alert.id}`">
                        {{ alert.alert_name }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active">Delete Alert</li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-6 col-12 mb-lg-0 mb-3">
                    <div class="card">
                        <div class="card-header">
                            Delete Alert
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>WARNING:</strong> You are about to delete this training course email alert and all its recipients. This cannot be undone. Do you wish to continue?
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-danger" v-on:click="deleteAlert()" :disabled="saving">
                                <template v-if="!saving">Yes, Delete this Training Course Alert Rule</template>
                                <template v-else>Deleting...</template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                saving: false,
                errors: {},
                alert: {},
            }
        },

        methods: {
            //Load the Account
            getAlert(){
                //Send it
                this.$http.get('training-courses/alerts/view/' + this.id)
                    .then(res => {
                        //Set data
                        this.alert = res.data.alert;

                        //Emails
                        this.emails = res.data.emails;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteAlert(){
                //Doing it
                this.saving = true;

                //Send it
                this.$http.post('training-courses/alerts/delete/' + this.id)
                    .then(res => {
                        //Alert
                        this.$toastr.success('Training Course Alert Deleted');

                        //Push
                        this.$router.push('/training-courses/alerts');
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted(){
            //Get it
            this.getAlert();
        }
    }
</script>
